import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { Router, Route, IndexRoute, browserHistory } from "react-router";
import firebase from "firebase";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "react-tabs/style/react-tabs.css";
import "react-select/dist/react-select.css";

import "./index.css";
import App from "./containers/App/App";
import Login from "./containers/Login/Login";
import NotFound from "./containers/NotFound/NotFound";
import Dashboard from "./containers/Dashboard/Dashboard";
import PictureManagement from "./containers/PictureManagement/PictureManagement";
import UserManagement from "./containers/UserManagement/UserManagement";
import registerServiceWorker from "./registerServiceWorker";
import rootReducer from "./reducers";

const middleswares = [thunk];
const store = createStore(rootReducer, applyMiddleware(...middleswares));

//Init Firebase
const config = {
  apiKey: "AIzaSyCe_Xt__m4WQKhBd6sKizvh3imEQReXA0g",
  authDomain: "picnowtest.firebaseapp.com",
  databaseURL: "https://picnowtest.firebaseio.com",
  projectId: "picnowtest",
  storageBucket: "picnowtest.appspot.com",
  messagingSenderId: "323233553771"
};
export const firebaseConfigurated = firebase.initializeApp(config);

const Index = () => (
  <Provider store={store}>
    <Router history={browserHistory}>
      <Route path="/" component={App}>
        <IndexRoute component={Login} />
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/picturemanagement" component={PictureManagement} />
        <Route path="/usermanagement" component={UserManagement} />
        <Route path="*" component={NotFound} />
      </Route>
    </Router>
  </Provider>
);

ReactDOM.render(<Index />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// /src/index.js